<template>
  <div id="login">
    <Layout>
      <Header></Header>
      <Layout>
        <Layout :style="{padding: '24px 24px 24px',  height: '93vh'}">
          <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
            <div class="login text-center">
              <form>
                <div class="form-group">
                  <label >Account</label>
                  <input v-model="account" type="account" class="form-control" aria-describedby="emailHelp" placeholder="Enter Account">
                </div>
                <div class="form-group">
                  <label >Password</label>
                  <input v-model="password" type="password" class="form-control" placeholder="Password">
                </div>
              </form>
              <Button type="primary" @click="login">Submit</Button>
            </div>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>

<script>
import {API} from '@/assets/config'

export default {
  name: 'login',
  data () {
    return {
      account: '',
      password: ''
    }
  },
  methods: {
    login () {
      let form = new FormData()
      form.append('account', this.account)
      form.append('password', this.password)
      let payload = {
        account: this.account,
        password: this.password
      }
      this.axios.post(API.login, payload)
        .then(res => {
          console.log(res)
          localStorage.setItem('token', res.data.token)
          this.$router.push({name: 'index'})
        })
        .catch(err => {
          this.errorHandle(err)
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.login {
  margin: 60px auto;
  padding: 50px;
  width: 500px;
  border: 1px solid #e4e4e4;
  border-radius: 5px;
  background-color: #f5f7f9;
}

.ivu-layout-header {
  height: 7vh;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue